import { Box, styled } from '@planne-software/uni/mui/material';

export const FieldsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
});

export const PersonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  '&:not(:last-child)': {
    borderBottom: `0.0625rem solid ${theme.tokens.colors['text-color-neutral-softer']!}`,
    paddingBottom: '1rem',
  },
}));

export const LoadingText = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-regular'],
  fontFamily: theme.typography.fontFamily,
  color: theme.tokens.colors['text-color-neutral-stronger'],
  textAlign: 'center',
  margin: 0,
  padding: '1.25rem',
}));
